export const hasFilterValue = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === "boolean") return value;
    if (typeof value === "string") return value.trim() !== "";
    if (Array.isArray(value)) return value.length > 0;

    return true;
}

export const countAppliedFilters = (filter) => {
    return Object.values(filter).filter(hasFilterValue).length;
}
